import {KTIcon} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'

interface Props {
  onClose?: () => void
}

const InvoiceLogModalHeader = ({onClose}: Props) => {
  const {setItemIdForUpdateLog} = useListView()

  const closeModal = () => {
    if (onClose) {
      onClose()
      return
    }
    setItemIdForUpdateLog?.(undefined)
  }
  return (
    <div className='modal-header'>
      <div className='card-body p-5'>
        <div className='d-flex justify-content-end'>
          <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-kt-users-modal-action='close'
            onClick={() => closeModal()}
            style={{cursor: 'pointer'}}
          >
            <KTIcon iconName='cross' className='fs-1' />
          </div>
        </div>

        <h1 className='fw-bold mb-2'>Cobranças</h1>
      </div>
    </div>
  )
}

export {InvoiceLogModalHeader}
